import { FormattedMessage } from "react-intl";
import { Button, Heading, Text } from "@lendcord/concord";
import type { ReportType } from "@/features/reports/reports.types";

function handleGenerate() {
  // TODO: wire to the real report generation/download flow once it exists.
}

interface ReportCardProps {
  report: ReportType;
}

export function ReportCard({ report }: ReportCardProps) {
  return (
    <div className="mx-auto max-w-md rounded-md border border-border bg-surface-raised p-8 text-center shadow-sm">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent-50" aria-hidden="true">
        <div className="h-6 w-6 rounded-full bg-accent-600" />
      </div>

      <Heading level={3} className="mt-4">
        {report.title}
      </Heading>
      <Text size="sm" variant="muted" className="mt-2">
        {report.description}
      </Text>

      <Button type="button" onClick={handleGenerate} className="mt-8 w-full">
        <FormattedMessage id="lender.reports.generateButton" />
      </Button>
    </div>
  );
}
